import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DeviceDetector } from 'src/app/services/segment/device-detector';

@UntilDestroy()
@Component({
  selector: 'app-start-demo-widget',
  templateUrl: './start-tutorial-widget.component.html',
  styleUrls: ['./start-tutorial-widget.component.scss'],
  standalone: false,
})
export class StartDemoWidgetComponent implements OnInit {
  @Output() dialogOpened = new EventEmitter<void>();
  @Output() dialogClosed = new EventEmitter<void>();
  @Input() label: string;

  constructor(
    public deviceDetector: DeviceDetector,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) { }

  ngOnInit(): void {
  }

  closeStartDemoDialog(): void {
    this.dialogClosed.emit();
  }

  openStartDemoDialog(): void {
    this.dialogOpened.emit();
  }
}
